/* Dreamy – Theme JS */

/* Marker at JS er på (CSS bruker dette for hover-fallback) */
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {

  // --- Mobile nav toggle ---
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav  = document.getElementById('mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // --- Collection filter sidebar (mobile) ---
  const filtersToggle = document.getElementById('filters-toggle');
  const filtersPanel  = document.getElementById('collection-filters');
  const filtersClose  = document.getElementById('filters-close');

  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener('click', () => {
      filtersPanel.classList.toggle('open');
      document.body.style.overflow = filtersPanel.classList.contains('open') ? 'hidden' : '';
    });
  }

  if (filtersClose && filtersPanel) {
    filtersClose.addEventListener('click', () => {
      filtersPanel.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // --- Collection sort ---
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // --- Product gallery thumbnails ---
  const thumbs    = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.getElementById('product-gallery-main');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.dataset.src;
      }
    });
  });

  // --- Product variant selection ---
  const optionBtns = document.querySelectorAll('.product__option-btn');
  const variantInput = document.getElementById('product-variant-id');

  if (optionBtns.length && variantInput) {
    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const position = btn.dataset.option;
        document.querySelectorAll(`.product__option-btn[data-option="${position}"]`)
          .forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  }

  // --- Quick add to cart ---
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = 'Legger til…';
      btn.disabled = true;

      try {
        if (window.DreamyCart) {
          // Adds the item and slides in the cart drawer (Sinful-style popup)
          await window.DreamyCart.addAndOpen([{ id: variantId, quantity: 1 }]);
        } else {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          updateCartCount();
        }
        btn.textContent = 'Legg i kurv';
        btn.disabled = false;
      } catch {
        btn.textContent = 'Prøv igjen';
        btn.disabled = false;
      }
    });
  });

  // --- Cart item quantity update ---
  document.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key     = btn.dataset.key;
      const action  = btn.dataset.action;
      const qtyEl   = btn.closest('.cart-item__qty').querySelector('.cart-item__qty-value');
      let qty = parseInt(qtyEl.textContent, 10);

      qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        window.location.reload();
      } catch {
        console.error('Could not update cart');
      }
    });
  });

  // --- Cart item remove ---
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        window.location.reload();
      } catch {
        console.error('Could not remove item');
      }
    });
  });

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.header__cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          const cartLink = document.querySelector('.header__cart');
          const el = document.createElement('span');
          el.className = 'header__cart-count';
          el.textContent = cart.item_count;
          cartLink?.appendChild(el);
        } else {
          badge.textContent = cart.item_count;
        }
      }
    } catch { /* silent */ }
  }
});

/* ── Nav-dropdown hover-intent (Sinful-stil) ──────────────────────
   Åpner ikke momentant: liten forsinkelse før åpning (så den ikke
   trigges når musa bare drar forbi) + luke-forsinkelse ved lukking
   (så den ikke lukker om du krysser diagonalt ned til menyen).      */
(function () {
  const OPEN_DELAY  = 200;  // ms før menyen åpnes (som Sinful/Radix)
  const CLOSE_DELAY = 200;  // ms før menyen begynner å lukke
  const ANIM        = 200;  // må matche .2s i CSS-animasjonen
  const items = document.querySelectorAll('header nav ul li.has-dropdown');
  if (!items.length) return;

  let openTimer, closeTimer;
  const closeTimers = new WeakMap();

  // Spill lukke-animasjonen, fjern så .is-closing når den er ferdig
  function startClose(li) {
    if (!li.classList.contains('is-open')) return;
    li.classList.remove('is-open');
    li.classList.add('is-closing');
    clearTimeout(closeTimers.get(li));
    closeTimers.set(li, setTimeout(() => li.classList.remove('is-closing'), ANIM));
  }

  function openNow(li) {
    items.forEach((o) => { if (o !== li) startClose(o); });   // kun én åpen om gangen
    clearTimeout(closeTimers.get(li));
    li.classList.remove('is-closing');
    li.classList.add('is-open');
  }

  items.forEach((li) => {
    li.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => openNow(li), OPEN_DELAY);
    });
    li.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => startClose(li), CLOSE_DELAY);
    });
    // Tastatur-tilgjengelighet
    li.addEventListener('focusin', () => openNow(li));
    li.addEventListener('focusout', (e) => {
      if (!li.contains(e.relatedTarget)) startClose(li);
    });
  });

  // Esc lukker alt
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') items.forEach(startClose); });
})();

/* ── Tomt søk skal ikke gjøre noe ───────────────────────────────────────────
   Sinful sitt søkefelt ligger ikke i et skjema i det hele tatt, så Enter og
   klikk på ikonet gjør ingenting når feltet er tomt. Vi beholder skjemaet
   (fungerer uten JS) og stopper bare innsending når det ikke er noe å søke
   på. Gjelder både Enter og søkeknappen, siden begge utløser submit. */
(function () {
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.getAttribute('action') !== '/search') return;
    const field = form.querySelector('input[name="q"]');
    if (!field) return;
    if (field.value.trim() === '') {
      e.preventDefault();
      // Tilbake til utgangspunktet: slipp fokus, så tykk kant og sort ikon
      // går tilbake til tynn kant og grått ikon.
      if (document.activeElement && form.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      field.blur();
    }
  });
})();

/* ── Fargesirkler på produktkort ────────────────────────────────────────────
   Sinful markerer hover og aktiv likt (sort kant), og kortbildet viser
   fargen som er markert. Her forhåndsvises fargen når man holder musa over,
   og kortet går tilbake til utgangspunktet når musa forlater det. */
(function () {
  var cache = {};
  function preload(url) { if (url && !cache[url]) { var i = new Image(); i.src = url; cache[url] = i; } }

  document.addEventListener('mouseover', function (e) {
    var kort = e.target.closest ? e.target.closest('.product-card') : null;
    if (!kort) return;
    // Forhåndslast alle fargebildene så snart musa er innom kortet → hover blir umiddelbar
    if (!kort.dataset.swPreloaded) {
      kort.dataset.swPreloaded = '1';
      kort.querySelectorAll('.card-swatch').forEach(function (s) { preload(s.dataset.img); });
    }
    var sw = e.target.closest('.card-swatch');
    if (!sw) return;
    var bilde = kort.querySelector('.product-card-img img');
    if (bilde && sw.dataset.img) {
      if (!bilde.dataset.opprinnelig) bilde.dataset.opprinnelig = bilde.currentSrc || bilde.src;
      bilde.removeAttribute('srcset');   // ellers overstyrer srcset src-en
      bilde.src = sw.dataset.img;
    }
    kort.querySelectorAll('.card-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
  });

  // Gå tilbake til utgangsfargen straks musa forlater fargesirkelen
  // (med mindre den går rett videre til en annen sirkel i samme kort).
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest ? e.target.closest('.card-swatch') : null;
    if (!sw) return;
    var kort = sw.closest('.product-card');
    if (!kort) return;
    var til = e.relatedTarget;
    if (til && til.closest && kort.contains(til) && til.closest('.card-swatch')) return;
    var bilde = kort.querySelector('.product-card-img img');
    if (bilde && bilde.dataset.opprinnelig) bilde.src = bilde.dataset.opprinnelig;
    kort.querySelectorAll('.card-swatch').forEach(function (s, i) { s.classList.toggle('is-active', i === 0); });
  });
})();
